var VerticalLayout1Module = /** @class */ (function () {
    function VerticalLayout1Module() {
    }
    return VerticalLayout1Module;
}());
export { VerticalLayout1Module };
